import { useEffect } from 'react';

const QConnect = () => {
  useEffect(() => {
    // Check if QConnect is available
    if (typeof window.QConnect === 'undefined') {
      console.warn('QConnect script not loaded yet');
      return;
    }

    // Single theme using light theme green as primary
    const widgetTheme = {
      primaryColor: '#059669', // light theme emerald green
      primaryHoverColor: '#047857', // darker emerald
      backgroundColor: '#ffffff', // white background
      textColor: '#0f172a', // dark text
      textLightColor: 'rgba(15, 23, 42, 0.8)', // secondary text
      borderColor: 'rgba(15, 23, 42, 0.08)', // light border
    };

    // Initialize QConnect with fixed theme
    window.QConnect.init({
      key: 'qm_ca_3FvoteCUWlAuXxS6Cf0DiarCGu4GE8vuH1rZsPNqlrQ',
      apiUrl: 'https://api.prod.quartermaster.io',
      position: 'bottom-right',
      greeting: 'Hello! 👋 How can I help you today?',
      title: 'Chat with us',
      theme: widgetTheme,
    });

    // Cleanup on unmount
    return () => {
      if (window.QConnect && typeof window.QConnect.destroy === 'function') {
        window.QConnect.destroy();
      }
    };
  }, []); // Only initialize once on mount

  return null; // This component doesn't render anything
};

export default QConnect;
